import { useEffect, useState } from 'react';
import {
  loadMeetingPlatforms, meetingPlatforms, subscribeMeetingPlatforms,
  supportedPlatformsShort, supportedPlatformsText,
} from '../lib/recognition/routeLink';

/**
 * Площадки бота на встречах для подписей экрана.
 *
 * Сразу отдаёт то, что известно (запасной список или уже пришедший ответ), и
 * спрашивает бота, какие площадки включены в админке; ответ перерисовывает
 * подпись. Запрос один на сессию — его держит loadMeetingPlatforms.
 *
 * Returns:
 *   { platforms, text, short } — список, «А, Б и В» и короткая строка для плитки.
 */
export function useMeetingPlatforms() {
  const [platforms, setPlatforms] = useState(meetingPlatforms);

  useEffect(() => {
    let alive = true;
    const unsubscribe = subscribeMeetingPlatforms((list) => { if (alive) setPlatforms(list); });
    // Ответ мог прийти, пока компонент монтировался, — подхватываем его.
    setPlatforms(meetingPlatforms());
    loadMeetingPlatforms();
    return () => { alive = false; unsubscribe(); };
  }, []);

  return {
    platforms,
    text: supportedPlatformsText(platforms),
    short: supportedPlatformsShort(platforms),
  };
}
